/**
 * Where a given user's "home" is — the page they land on at login, and the page an
 * Unauthorized or Not-Found screen offers to send them back to.
 *
 * Extracted from the router guard (2026-09-15) so the guard and UnauthorizedView cannot
 * disagree. They used to: the guard sent a title rep to /dispatch, while Unauthorized's
 * "Go to Dashboard" button pushed `/`, which is admin-only — so the button bounced them
 * through the guard a second time to get to the same place.
 *
 * `/` is admin-only, and the Hold/Red Calculator is the dispatch-admin landing, so every
 * role that is neither gets an explicit home here:
 *   dispatch / intake / title / title_supervisor  → the Work Queue (2026-08-06)
 *   email_rep / quoter / email_manager            → the Email/RV lead queue (2026-08-15)
 * Managers and super_admins (canViewAll) fall through to the calculator, which is their
 * existing landing.
 *
 * Safe from redirect loops: every destination accepts the roles that route to it.
 */
export function homeRouteFor(hasRole, canViewAll) {
  const viewAll = canViewAll?.value ?? canViewAll
  if (!viewAll) {
    // texter (2026-10-12): Textline agents imported with Conversations as their only screen.
    if (hasRole('texter')) return { name: 'conversations' }
    if (hasRole('dispatch') || hasRole('intake') || hasRole('title') || hasRole('title_supervisor')) {
      return { name: 'dispatch' }
    }
    if (hasRole('email_rep') || hasRole('quoter') || hasRole('email_manager')) {
      return { name: 'emailrv-queue' }
    }
  }
  return { name: 'hold-calculator' }
}
